import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { register } from '../../api/auth';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    password2: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setErrors((er) => ({ ...er, [e.target.name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password2) {
      setErrors({ password2: 'Лозинките не се совпаѓаат' });
      return;
    }
    setLoading(true);
    try {
      await register(form);
      toast.success('Сметката е создадена! Ве молиме најавете се.');
      navigate('/login');
    } catch (err) {
      const data = err.response?.data || {};
      if (typeof data === 'object') {
        const fieldErrors = {};
        Object.keys(data).forEach((k) => {
          fieldErrors[k] = Array.isArray(data[k]) ? data[k][0] : data[k];
        });
        setErrors(fieldErrors);
      } else {
        toast.error('Регистрацијата не успеа.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-green-100">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8">
        <div className="text-center mb-8">
          <span className="text-4xl">🌱</span>
          <h1 className="mt-2 text-2xl font-bold text-gray-800">Создај сметка</h1>
          <p className="text-gray-500 text-sm mt-1">Приклучете се на AgroPlatform денес</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Корисничко име"
            name="username"
            value={form.username}
            onChange={handleChange}
            error={errors.username}
            required
            placeholder="земјоделец_јован"
          />
          <Input
            label="Е-пошта"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            error={errors.email}
            required
            placeholder="jovan@farma.com"
          />
          <Input
            label="Лозинка"
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            error={errors.password}
            required
            placeholder="••••••••"
          />
          <Input
            label="Потврди лозинка"
            name="password2"
            type="password"
            value={form.password2}
            onChange={handleChange}
            error={errors.password2}
            required
            placeholder="••••••••"
          />
          <Button type="submit" loading={loading} className="w-full mt-2" size="lg">
            Создај сметка
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-gray-500">
          Веќе имате сметка?{' '}
          <Link to="/login" className="text-green-700 font-medium hover:underline">
            Најавете се
          </Link>
        </p>
      </div>
    </div>
  );
}
